import _ from 'lodash';

export default class Supplier {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.mail = _.get(data, 'mail', '');
    this.name = _.get(data, 'name', '');
    this.shopIds = _.get(data, 'shopIds', '');
    this.orderType = _.get(data, 'orderType', '');
    this.supplierId = _.get(data, 'supplierId', '');
    this.order_constraint = _.get(data, 'order_constraint', '');
  }
}
